import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

import { CardContent, CardMedia } from '@mui/material';
import dayjs from 'dayjs';

import { News } from 'api/news';

import { Card, Title } from 'common';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../../context/LanguageContext'

interface NewsCardProps {
    newsItem: News;
}

export const NewsCard = ({ newsItem }: NewsCardProps) => {
    const { language } = useLanguage();
    return (
        <Link to={`/news/${newsItem.id}`} style={{ textDecoration: 'none' }}>
            <Card sx={{ width: '100%', maxWidth: 400, marginBottom: 2, border: '1px solid #af0000' }}>
                {newsItem.images && newsItem.images.length > 0 && newsItem.images[0] ? (
                    <CardMedia
                        component="img"
                        height="200"
                        sx={{ borderRadius: 1 }}
                        image={newsItem.images[0].photo}
                        alt={newsItem.title}
                    />
                ) : (
                    <ImageNotSupportedIcon
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '5rem'
                        }}
                    />
                )}
                <CardContent>
                    <Title
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            fontWeight: 600,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {newsItem[`title_${language}`]}
                    </Title>
                    <Title
                        gutterBottom
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4, 
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: newsItem[`description_${language}`] }} />

                    </Title>
                    <Title variant="body2" color="text.primary">
                        {dayjs(newsItem.created_at).format('DD.MM.YYYY')}
                    </Title>
                </CardContent>
            </Card>
        </Link>
    );
};
